var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCut = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.56152,
    y: 6.5,
    width: 27,
    height: 27,
    stroke: "#737478",
    strokeDasharray: "5 5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.56152,
    y: 30.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5615,
    y: 30.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.56152,
    y: 4.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_927_19601)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(20.0615 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_927_19601",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0615 8.11328L20.1747 6.0001L36.5295 22.3549L34.4163 24.468L18.0615 8.11328Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.0615 8.11328L20.1747 6.0001L36.5295 22.3549L34.4163 24.468L18.0615 8.11328Z",
    fill: "#F87B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1747 6.0001L21.5882 4.58661L20.1747 3.17312L18.7612 4.58661L20.1747 6.0001ZM19.475 9.52677L21.5882 7.41359L18.7612 4.58661L16.648 6.69979L19.475 9.52677ZM18.7612 7.41359L35.116 23.7684L37.943 20.9414L21.5882 4.58661L18.7612 7.41359Z",
    fill: "#F87B0E",
    mask: "url(#path-5-inside-1_927_19601)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_927_19601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(20.0615 6)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cut.74b1ddce187c9bbc7590af6cf6f9cec8.svg";